const areWeightagesFilled = (assignments) =>
  assignments
    .map(({ weightage }) => typeof weightage === 'number')
    .every((isFilled) => isFilled);

export default areWeightagesFilled;
